import routerOptions0 from "/workspace/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/workspace/src/app/router.options.ts";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}